import { SCREEN_SIZES } from './constants';

export const throttleLite = (callback, limit) => {
  var wait = false;
  return function() {
    if (wait) {
      return;
    }
    callback.call();
    wait = true;
    setTimeout(function() {
      wait = false;
    }, limit);
  };
};

/**
 *
 * @param element
 * @param className
 */
export const eClick = (element, className) => {
  element.addEventListener('click', (e) => {
    e.preventDefault();
    if(!element.classList.contains(className)) {
      element.classList.add(className);
    } else {
      element.classList.remove(className);
    }
  });
};

/**
 *
 * @param elements
 * @param className
 */
export const eMultiClick = (elements, className) => {
  for(let i = 0; i < elements.length; i++) {
    eClick(elements[i], className);
  }
};

/**
 *
 * @param element
 * @param type
 * @param posFromTop
 */
export const animate = (element, type, posFromTop) => {
  let windowHeight = window.innerHeight;
  let elementPosFromTop = element.getBoundingClientRect().top;


  if((elementPosFromTop + posFromTop) <= windowHeight && !element.classList.contains(type)) {
    element.classList.add(type);
  }
};

/**
 *
 * @param func
 * @param wait
 * @param immediate
 * @returns {function()}
 */
export const debounce = (func, wait, immediate) => {
  let timeout;
  return () => {
    let context = this, args = arguments;
    let later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export const toTop = (element, speed) => {
  element.addEventListener('click', () => {
    //set initial speed of the scroll
    let scrollStep = -window.scrollY / (300 / speed),
      // send it into an interval function
      scrollInterval = setInterval(() => {
        if ( window.scrollY !== 0 ) {
          window.scrollBy( 0, scrollStep );
        }
        else clearInterval(scrollInterval);
      },speed);
  });
};

/**
 *
 * @returns {*}
 */
export const screenCategory = () => {
  let width = window.innerWidth;
  let size;

  if(width < SCREEN_SIZES.tablet.width) {
    size = SCREEN_SIZES.mobile.title;
  } else if(width >= SCREEN_SIZES.tablet.width && width < SCREEN_SIZES.desktop.width) {
    size = SCREEN_SIZES.tablet.title;
  } else {
    size = SCREEN_SIZES.desktop.title;
  }
  return size;
};


// ------
// SCROLL

export const scrollIt = (destination, duration = 200, easing = 'linear', callback) => {

  const easings = {
    linear(t) {
      return t;
    },
    easeInQuad(t) {
      return t * t;
    },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic(t) {
      return (--t) * t * t + 1;
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart(t) {
      return 1 - (--t) * t * t * t;
    },
    easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
    },
    easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint(t) {
      return 1 + (--t) * t * t * t * t;
    },
    easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
    }
  };

  const start = window.pageYOffset;
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

  const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  const destinationOffset = typeof destination === 'number' ? destination : destination.getBoundingClientRect().top + window.scrollY;
  const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  function scroll() {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, ((now - startTime) / duration));
    const timeFunction = easings[easing](time);
    window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

    if (window.pageYOffset === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    requestAnimationFrame(scroll);
  }

  scroll();
};

// equivalent to jQuery.ready():
export const ready = (callback) => {
  // in case the document is already rendered
  if (document.readyState !== 'loading') callback();
  // modern browsers
  else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
  // IE <= 8
  else document.attachEvent('onreadystatechange', function() {
    if (document.readyState === 'complete') callback();
  });
};

export const hideOnClickOutside = (element, mainElm) => {

  if (typeof mainElm === 'undefined') mainElm = element;

  const outsideClickListener = event => {
    if (!element.contains(event.target) && !mainElm.classList.contains('hidden')) {
      mainElm.classList.add('hidden');
      removeClickListener();
    }
  };

  const removeClickListener = () => {
    document.removeEventListener('click', outsideClickListener);
  };

  setTimeout(function() {
    document.addEventListener('click', outsideClickListener);
  },5);

  return outsideClickListener;
};
